import { render } from "./AdminMasterView.vue?vue&type=template&id=1f4eb4fd"
import script from "./AdminMasterView.vue?vue&type=script&lang=js"
export * from "./AdminMasterView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__